import SmallCard from '../cards/small-card'
import {
  StyledRecommendationsSection,
  StyledRecommendationsTitle,
  StyledCardScroller,
} from './details-page-styles'

type RecommendationItem = {
  id: number
  type: 'movie' | 'show'
  title: string
  year?: string
  rating: number
  posterUrl?: string
}

type RecommendationsSectionProps = {
  title: string
  items: RecommendationItem[]
}

const RecommendationsSection = ({
  title,
  items,
}: RecommendationsSectionProps) => {
  if (!items.length) {
    return null
  }

  return (
    <StyledRecommendationsSection>
      <StyledRecommendationsTitle>{title}</StyledRecommendationsTitle>
      <StyledCardScroller>
        {items.map((rec) => (
          <SmallCard
            key={rec.id}
            id={rec.id}
            type={rec.type}
            title={rec.title}
            year={rec.year || ''}
            rating={rec.rating}
            posterUrl={rec.posterUrl}
          />
        ))}
      </StyledCardScroller>
    </StyledRecommendationsSection>
  )
}

export default RecommendationsSection
